

import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { StartKitChooserComponent } from '@app/customizer-shared/components/start-kit-chooser/start-kit-chooser.component';

import { BaseModal } from '@modals/base-modal';
import { OrderItemModel } from '@models/order-item';
import { StartKitModel } from '@models/start-kit-model';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { OrderOnBehalfService } from '@services/order-on-behalf.service';

@Component({
	selector: 'app-start-kits-modal',
	templateUrl: './start-kits-modal.component.html',
	styleUrls: ['./start-kits-modal.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [StartKitChooserComponent],
})
export class StartKitsModalComponent extends BaseModal {
	@Output() resultChange = new EventEmitter<StartKitsModalData>();
	@Input() productLineCode: string;
	@Input() kidTeen: boolean;
  @Input() orderItem: OrderItemModel;

	@Input() customerNo?: string;
	@Input() newOrderSelected?: boolean;

	constructor(
		breadcrumbService: BreadcrumbService,
		public orderOnBehalfService: OrderOnBehalfService
	) {
		super(breadcrumbService);
	}

	public setAndDestroy(
    orderItem: OrderItemModel,
		customerNo?: string,
		newOrderSelected?: boolean,
		startKitModel?: StartKitModel
	) {
		this.resultChange.emit({
      orderItem,
			customerNo,
			newOrderSelected,
			startKitModel
		});
		this.closeAndDestroy();
	}
}

export interface StartKitsModalData {
  orderItem: OrderItemModel
	customerNo?: string;
	newOrderSelected?: boolean;
	startKitModel?: StartKitModel;
}
